import * as React from "react";
import type { SVGProps } from "react";
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#74758C"
      d="m8.59 6.5 4.454-4.453a1.126 1.126 0 0 0-1.59-1.594L7 4.906 2.547.453A1.127 1.127 0 1 0 .953 2.047L5.406 6.5.953 10.953a1.127 1.127 0 0 0 1.594 1.594L7 8.094l4.453 4.453a1.127 1.127 0 0 0 1.594-1.594z"
    />
  </svg>
);
export default SvgClose;
